export default class CareerAptitudeTestQuestion{
    id;
    question;

    constructor(data){
        this.id=data?.id;
        this.question=data?.question;
    }
}